import Icon from "@Components/generic/icon";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { InputAdornment, TextField, TextFieldProps, styled } from "@mui/material";

export const PlaylistSearchField = styled((props: TextFieldProps) => (
  <TextField
    {...props}
    variant="filled"
    InputProps={{
      disableUnderline: true,
      startAdornment: (
        <InputAdornment position="end">
          <Icon icon={faSearch} />
        </InputAdornment>
      ),
      ...props.InputProps,
    }}
  />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    backgroundColor: theme.palette.dsBase.v100,
    borderRadius: theme.spacing(1.5),
    boxShadow: `0 0 0 1px ${theme.palette.dsSurface.v300}`,
    ":hover": {
      backgroundColor: theme.palette.dsBase.v100,
      boxShadow: `0 0 0 1.5px ${theme.palette.dsSurface.v400}`,
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 1.5px ${theme.palette.dsSurface.v400}`,
    },
  },
  "& .MuiFilledInput-input": {
    fontSize: theme.typography.textS500.fontSize,
    padding: theme.spacing(1.75, 2),
    "&::placeholder": {
      color: theme.palette.dsNeutral.v300,
    },
  },
}));
